import React, { useEffect, useState, createElement, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, Clock, TrendingUp, ShieldCheck, Users, Star, ChevronDown, ChevronUp, FileText, Smartphone, Award, AlertTriangle, Check, ChevronLeft, ChevronRight } from 'lucide-react';
// --- Components ---
const MetaPixel = () => {
  useEffect(() => {
    const pixelId = '890245410416880';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
};
const FakePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [popupData, setPopupData] = useState({
    name: '',
    city: '',
    role: ''
  });
  const names = ['Martín', 'Lucía', 'Alejandro', 'Sofía', 'Diego', 'Valentina', 'Carlos', 'María'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata'];
  const roles = ['Cirujano Plástico', 'Cirujana Estética', 'Médico Especialista', 'Director Médico'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomRole = roles[Math.floor(Math.random() * roles.length)];
      setPopupData({
        name: randomName,
        city: randomCity,
        role: randomRole
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-0">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl p-3 md:p-4 flex items-center gap-3 md:gap-4 max-w-[90%] md:max-w-sm border-l-4 border-amber-500" data-id="element-1">
          <div className="bg-green-100 p-1.5 md:p-2 rounded-full shrink-0" data-id="element-2">
            <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-600" data-id="element-3" />
          </div>
          <div data-id="element-4">
            <p className="text-xs md:text-sm text-gray-800 font-medium" data-id="element-5">
              <span className="font-bold" data-id="element-6">{popupData.name}</span> de{' '}
              {popupData.city}
            </p>
            <p className="text-[10px] md:text-xs text-gray-500" data-id="element-7">
              {popupData.role}
            </p>
            <p className="text-[10px] md:text-xs text-amber-600 font-semibold mt-0.5 md:mt-1" data-id="element-8">
              Acaba de comprar el MegaPack
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const FloatingMockup = () => {
  return <div className="relative w-full max-w-2xl mx-auto my-6 md:my-8" data-id="element-9">
      <motion.div animate={{
      y: [0, -10, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="relative z-10" data-id="element-10">
        <img src="https://cdn.magicpatterns.com/uploads/vFf7Q9eQyyTSrZwWBTn7S1/MEGAPACK_ELITE_CIRUJANO.png" alt="MegaPack EliteCirujano" className="w-[70%] mx-auto drop-shadow-[0_0_30px_rgba(245,158,11,0.3)] object-contain" data-id="element-11" />
      </motion.div>
      <motion.div animate={{
      opacity: [0.3, 0.6, 0.3],
      scale: [0.8, 1, 0.8]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[60%] h-6 bg-amber-500/20 blur-xl rounded-[100%] z-0" data-id="element-12" />
    </div>;
};
const TestimonialCarousel = () => {
  const testimonials = [{
    name: 'Marcelo R.',
    role: 'Cirujano Plástico · Buenos Aires',
    text: 'Con el MegaPack EliteCirujano pude sistematizar mi consulta y liberar más de 8 horas a la semana. Ahora atraigo pacientes ideales y trabajo con mucha más tranquilidad.'
  }, {
    name: 'Valeria F.',
    role: 'Cirujana Estética · Córdoba',
    text: 'La guía de comunicación y marketing cambió mi forma de relacionarme con mis pacientes. Más confianza, menos preguntas repetidas y más tiempo para mi familia.'
  }, {
    name: 'Camilo P.',
    role: 'Cirujano Plástico · Rosario',
    text: 'Los protocolos quirúrgicos y checklists mejoraron mis resultados. Sentí un antes y después en mi carrera.'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <div className="w-full max-w-xl mx-auto py-6 relative" data-id="element-13">
      <div className="overflow-hidden relative px-10 md:px-12" data-id="element-14">
        <AnimatePresence mode="wait" data-id="element-15">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-xl p-5 md:p-6 border border-slate-200 shadow-sm mx-auto" data-id="element-16">
            <div className="flex justify-center text-amber-400 mb-3" data-id="element-17">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-18" />)}
            </div>
            <p className="text-slate-700 text-sm md:text-base italic mb-4 text-center" data-id="element-19">
              "{testimonials[currentIndex].text}"
            </p>
            <div className="flex flex-col items-center gap-1.5" data-id="element-20">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white font-bold text-lg shadow-sm" data-id="element-21">
                {testimonials[currentIndex].name.charAt(0)}
              </div>
              <div className="text-center" data-id="element-22">
                <p className="text-slate-900 font-bold text-sm" data-id="element-23">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-slate-500 text-xs" data-id="element-24">
                  {testimonials[currentIndex].role}
                </p>
                <p className="text-green-600 text-[10px] flex items-center justify-center gap-1 mt-0.5" data-id="element-25">
                  <CheckCircle2 className="w-3 h-3" data-id="element-26" /> Verificado
                </p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white hover:bg-slate-50 text-amber-600 p-1.5 md:p-2 rounded-full border border-slate-200 shadow-sm transition-colors z-10" data-id="element-27">
        <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" data-id="element-28" />
      </button>
      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white hover:bg-slate-50 text-amber-600 p-1.5 md:p-2 rounded-full border border-slate-200 shadow-sm transition-colors z-10" data-id="element-29">
        <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-30" />
      </button>
    </div>;
};
const VistaPrevia = () => {
  return <section className="py-10 md:py-16 px-4 bg-[#0a0f1c] border-y border-amber-500/20 relative overflow-hidden" data-id="element-31">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagonal-stripes.png')] opacity-5" data-id="element-32"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-33">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-34">
          VISTA PREVIA
        </h2>
        <h3 className="text-lg md:text-2xl text-amber-500 font-semibold mb-3 md:mb-4" data-id="element-35">
          Explorá el interior del Megapack
        </h3>
        <p className="text-sm md:text-base text-slate-300 mb-6 md:mb-10" data-id="element-36">
          Conocé la calidad de nuestros protocolos, plantillas y checklists
        </p>

        <div className="relative rounded-2xl overflow-hidden border-2 border-amber-500/30 shadow-[0_0_30px_rgba(245,158,11,0.15)] bg-black aspect-[9/16] max-w-xs md:max-w-sm mx-auto" data-id="element-37">
          <video src="https://cdn.magicpatterns.com/uploads/u56yBobuEKt1CSukgYTQZj/screenrecording.mov" controls autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-38" />
        </div>
      </div>
    </section>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 py-3 md:py-4" data-id="element-39">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center text-left focus:outline-none" data-id="element-40">
        <span className="text-slate-800 font-medium pr-4 text-sm md:text-base" data-id="element-41">
          {question}
        </span>
        {isOpen ? <ChevronUp className="text-amber-500 shrink-0 w-5 h-5" data-id="element-42" /> : <ChevronDown className="text-amber-500 shrink-0 w-5 h-5" data-id="element-43" />}
      </button>
      <AnimatePresence data-id="element-44">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-45">
            <p className="text-slate-600 mt-2 md:mt-3 text-xs md:text-sm leading-relaxed" data-id="element-46">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const PricingSection = () => {
  return <section id="pricing" className="py-10 md:py-16 bg-[#0a0f1c] px-4 relative overflow-hidden" data-id="element-47">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagonal-stripes.png')] opacity-5" data-id="element-48"></div>
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-49">
        <div className="text-center mb-8 md:mb-12" data-id="element-50">
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-3 md:mb-4" data-id="element-51">
            ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-sm md:text-base text-slate-400" data-id="element-52">
            Incluye los 7 Tomos y los 5 bonos exclusivos.
          </p>
        </div>

        <div className="flex justify-center items-center" data-id="element-53">
          {/* Single Plan (Styled like PRO) */}
          <div className="w-full max-w-lg bg-gradient-to-b from-blue-900 to-slate-900 border-2 border-amber-500 rounded-2xl p-6 md:p-8 flex flex-col relative shadow-[0_0_40px_rgba(245,158,11,0.15)]" data-id="element-54">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-500 text-white font-bold px-6 py-1.5 rounded-full text-xs md:text-sm shadow-lg whitespace-nowrap" data-id="element-55">
              OFERTA ESPECIAL
            </div>

            <div className="mb-6 mt-2 text-center" data-id="element-56">
              <h4 className="text-2xl md:text-3xl font-bold text-white" data-id="element-57">
                MegaPack EliteCirujano
              </h4>
              <p className="text-blue-300 text-sm mt-2" data-id="element-58">7 Tomos + 5 Bonos</p>
            </div>

            <div className="mb-8 text-center" data-id="element-59">
              <p className="text-slate-400 line-through text-xs md:text-sm mb-1" data-id="element-60">
                Precio normal $59.990
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-61">
                <span className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-62">
                  $20.990
                </span>
                <span className="text-slate-300 text-xs md:text-sm" data-id="element-63">ARS</span>
              </div>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-64">
              <li className="flex items-center gap-2 text-xs md:text-sm text-white font-medium" data-id="element-65">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-amber-400 shrink-0" data-id="element-66" />{' '}
                Acceso inmediato
              </li>
              <li className="flex items-center gap-2 text-xs md:text-sm text-white font-medium" data-id="element-67">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-amber-400 shrink-0" data-id="element-68" />{' '}
                Garantía 7 días
              </li>
              <li className="flex items-center gap-2 text-xs md:text-sm text-white font-medium" data-id="element-69">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-amber-400 shrink-0" data-id="element-70" />{' '}
                7 Tomos Base
              </li>
              <li className="flex items-center gap-2 text-xs md:text-sm text-white font-medium" data-id="element-71">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-amber-400 shrink-0" data-id="element-72" />{' '}
                5 Bonos Exclusivos
              </li>
            </ul>

            <a href="https://elitecirujano-cirugia-profesional.impultienda.ar/checkout" className="w-full block text-center bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white font-bold text-base md:text-lg py-3 md:py-4 rounded-xl shadow-lg transition-all transform hover:scale-[1.02]" data-id="element-73">
              💥 COMPRAR MEGAPACK AHORA
            </a>
            <p className="text-center text-[10px] md:text-xs text-slate-400 mt-3 md:mt-4" data-id="element-74">
              Pago seguro · Acceso en 5 minutos
            </p>
          </div>
        </div>
      </div>
    </section>;
};
// --- Main App ---
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-amber-500/30 relative" data-id="element-75">
      {/* Global Background Effects - Subtle diagonal lines */}
      <div className="fixed inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagonal-stripes.png')] opacity-[0.03] pointer-events-none z-0" data-id="element-76"></div>

      <div className="relative z-10" data-id="element-77">
        <MetaPixel data-id="element-78" />
        <FakePopup data-id="element-79" />

        {/* Top Banner */}
        <div className="bg-gradient-to-r from-amber-700 via-amber-600 to-amber-700 text-white text-center py-2 px-4 text-[10px] md:text-xs font-semibold tracking-wide shadow-md" data-id="element-80">
          🔥 ATENCIÓN: OFERTA ESPECIAL POR TIEMPO LIMITADO
        </div>

        {/* Hero Section */}
        <header className="relative pt-8 md:pt-12 pb-10 md:pb-16 px-4 overflow-hidden bg-[#0a0f1c]" data-id="element-81">
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 md:mb-6 drop-shadow-lg" data-id="element-83">
              Optimiza tu <span className="text-amber-500" data-id="element-84">cirugía</span>, más{' '}
              <span className="text-blue-400" data-id="element-85">pacientes</span> y{' '}
              <span className="text-amber-500" data-id="element-86">tiempo</span> para vos
            </h1>

            <FloatingMockup data-id="element-87" />

            <p className="text-sm md:text-xl text-slate-300 mb-6 md:mb-8 max-w-3xl mx-auto font-medium" data-id="element-88">
              7 Tomos + 5 Bonos — PDF Digital · Acceso Inmediato. Protocolos,
              plantillas y estrategias para profesionalizar tu práctica.
            </p>

            <div className="relative inline-block group" data-id="element-89">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-600 to-red-600 rounded-full blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-90"></div>
              <a href="#pricing" className="relative inline-block bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white font-bold text-base md:text-xl py-3 md:py-4 px-6 md:px-8 rounded-full shadow-[0_0_20px_rgba(245,158,11,0.3)] transition-all transform hover:scale-105" data-id="element-91">
                💥 QUIERO MI MEGAPACK AHORA
              </a>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mt-6 md:mt-8 text-xs md:text-sm text-slate-400 font-medium" data-id="element-92">
              <span className="flex items-center gap-1.5 md:gap-2" data-id="element-93">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-green-500" data-id="element-94" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5 md:gap-2" data-id="element-95">
                <Users className="w-4 h-4 md:w-5 md:h-5 text-blue-400" data-id="element-96" /> +500
                Cirujanos lo usan
              </span>
              <span className="flex items-center gap-1.5 md:gap-2" data-id="element-97">
                <Star className="w-4 h-4 md:w-5 md:h-5 text-amber-400 fill-current" data-id="element-98" />{' '}
                4.9 Rating
              </span>
            </div>
          </div>
        </header>

        {/* Social Proof (Gray) */}
        <section className="py-10 md:py-12 bg-slate-100 border-y border-slate-200 relative" data-id="element-99">
          <div className="max-w-6xl mx-auto px-4 text-center relative z-10" data-id="element-100">
            <h2 className="text-xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-101">
              +500 CIRUJANOS PLÁSTICOS CONFÍAN EN MEGAPACK ELITECIRUJANO
            </h2>
            <p className="text-amber-600 font-semibold mb-6 md:mb-8 text-xs md:text-base" data-id="element-102">
              Lo que dicen los profesionales 4.9/5 ⭐
            </p>
            <TestimonialCarousel data-id="element-103" />
          </div>
        </section>

        {/* Vista Previa (Dark) */}
        <VistaPrevia data-id="element-104" />

        {/* Problem Section (White) */}
        <section className="py-10 md:py-16 px-4 relative bg-white" data-id="element-105">
          <div className="max-w-4xl mx-auto" data-id="element-106">
            <div className="text-center mb-8 md:mb-12" data-id="element-107">
              <p className="text-amber-600 font-bold tracking-widest text-xs md:text-sm uppercase mb-1 md:mb-2" data-id="element-108">
                La realidad del cirujano plástico
              </p>
              <h2 className="text-2xl md:text-4xl font-bold text-slate-900" data-id="element-109">
                ¿TE PASA ESTO?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-110">
              {[{
              icon: Clock,
              title: 'Falta de tiempo real',
              desc: 'Horas excesivas en tareas administrativas y comunicación manual.'
            }, {
              icon: AlertTriangle,
              title: 'Procesos poco claros',
              desc: 'Improvisás sin protocolos escritos y estandarizados.'
            }, {
              icon: TrendingUp,
              title: 'Poca captación',
              desc: 'Marketing por intuición, sin estrategia enfocada a pacientes ideales.'
            }, {
              icon: FileText,
              title: 'Estrés y ansiedad',
              desc: 'Agenda desordenada, consultas duplicadas y pacientes confundidos.'
            }, {
              icon: Smartphone,
              title: 'Confusión digital',
              desc: 'No sabes qué publicar ni cómo automatizar respuestas en redes.'
            }, {
              icon: Award,
              title: 'Mucha teoría, poca práctica',
              desc: 'Información dispersa sin aplicación directa para tu día a día.'
            }].map((item, i) => <div key={i} className="bg-slate-100 border border-slate-200 p-4 md:p-5 rounded-xl flex gap-3 md:gap-4 items-start hover:bg-slate-200 hover:-translate-y-1 transition-all shadow-sm" data-id="element-111">
                  <div className="bg-red-100 p-2 md:p-3 rounded-lg shrink-0" data-id="element-112">
                    <item.icon className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-113" />
                  </div>
                  <div data-id="element-114">
                    <h3 className="text-slate-900 font-bold mb-1 text-sm md:text-base" data-id="element-115">
                      {item.title}
                    </h3>
                    <p className="text-slate-600 text-xs md:text-sm leading-relaxed" data-id="element-116">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-8 md:mt-12 text-center" data-id="element-117">
              <p className="text-sm md:text-xl font-bold text-red-700 bg-red-50 inline-block py-2 md:py-3 px-4 md:px-6 rounded-lg border border-red-200 shadow-sm" data-id="element-118">
                ¿CUÁNTAS SEMANAS MÁS VAS A SEGUIR PERDIENDO HORAS INNECESARIAS?
              </p>
            </div>
          </div>
        </section>

        {/* Target Audience (Gray) */}
        <section className="py-10 md:py-16 bg-slate-100 px-4 relative border-y border-slate-200" data-id="element-119">
          <div className="max-w-4xl mx-auto text-center" data-id="element-120">
            <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-6 md:mb-10" data-id="element-121">
              ¿PARA QUIÉN ES?
            </h2>
            <p className="text-slate-600 mb-6 md:mb-8 text-sm md:text-base" data-id="element-122">
              Diseñado para vos, cirujano que quiere liberarse y hacer crecer su
              consulta:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 text-left" data-id="element-123">
              {['Cirujanos Plásticos que buscan sistematizar su práctica y ganar tiempo.', 'Profesionales que quieren atraer más pacientes con estrategias efectivas.', 'Cirujanos que desean protocolos quirúrgicos claros para evitar errores.', 'Médicos independientes o pequeños equipos que necesitan optimizar la comunicación.'].map((text, i) => <div key={i} className="flex items-center gap-3 bg-white p-3 md:p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-124">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 shrink-0" data-id="element-125" />
                  <span className="text-slate-700 text-xs md:text-sm" data-id="element-126">
                    {text}
                  </span>
                </div>)}
            </div>
            <p className="mt-6 md:mt-8 text-amber-600 font-medium text-xs md:text-sm" data-id="element-127">
              ¿No estás seguro? Tenés 7 días de garantía total.
            </p>
          </div>
        </section>

        {/* Content Section - 7 Tomos (White) */}
        <section className="py-10 md:py-16 px-4 relative bg-white" data-id="element-128">
          <div className="max-w-5xl mx-auto relative z-10" data-id="element-129">
            <div className="text-center mb-8 md:mb-12" data-id="element-130">
              <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2 md:mb-4" data-id="element-131">
                LOS 7 TOMOS DEL MEGAPACK
              </h2>
              <p className="text-slate-600 text-sm md:text-base" data-id="element-132">
                El sistema más completo para tu consulta plástica
              </p>
            </div>

            <div className="space-y-4 md:space-y-6" data-id="element-133">
              {[{
              num: 1,
              title: 'Protocolos Quirúrgicos Estandarizados',
              desc: 'Incluye plantillas para evaluación preoperatoria detallada, listas de chequeo intraoperatorias, manejo de complicaciones y protocolos postoperatorios para asegurar consistencia técnica y seguridad total.',
              img: 'https://images.unsplash.com/photo-1551076805-e1869033e561?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 2,
              title: 'Gestión Inteligente del Tiempo',
              desc: 'Herramientas para planificar quirófano, cronogramas de preparación, control de tiempos operatorios, gestión de agendas y seguimiento de indicadores clave para asegurar eficiencia máxima.',
              img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 3,
              title: 'Comunicación Efectiva y Seguimiento',
              desc: 'Modelos profesionales para consentimiento informado, protocolos de comunicación pre y post cirugía, formatos para registro de consultas y seguimientos automatizables para mejorar la adherencia al tratamiento.',
              img: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 4,
              title: 'Marketing Ético y Posicionamiento',
              desc: 'Sistema para registrar, tabular y analizar resultados, complicaciones y satisfacción del paciente con plantillas y gráficos para evaluación objetiva de desempeño quirúrgico.',
              img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 5,
              title: 'Manual de Respuestas y Scripts',
              desc: 'Formatos descargables para control preciso de turnos, cobros, historiales clínicos y documentación indispensable para optimizar la gestión clínica diaria.',
              img: 'https://images.unsplash.com/photo-1554774853-719586f82d77?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 6,
              title: 'Plantillas Administrativas Profesionales',
              desc: 'Protocolos para preparar al paciente preoperatorio con indicadores claros, seguimiento postoperatorio estructurado y checklist para minimizar riesgos y mejorar resultados.',
              img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80'
            }, {
              num: 7,
              title: 'Evaluación de Resultados y Mejora',
              desc: 'Herramientas para la autoevaluación, planificación de capacitaciones, revisión de protocolos y adaptación a nuevas técnicas con formatos prácticos para implementar actualizaciones.',
              img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80'
            }].map((tomo, i) => <div key={i} className="bg-slate-100 border border-slate-200 rounded-2xl overflow-hidden flex flex-col md:flex-row items-center group hover:border-amber-500/30 transition-all shadow-sm hover:shadow-md hover:-translate-y-1" data-id="element-134">
                  <div className="w-full md:w-1/3 h-40 md:h-auto relative overflow-hidden" data-id="element-135">
                    <div className="absolute inset-0 bg-blue-900/10 mix-blend-multiply z-10 group-hover:bg-transparent transition-all" data-id="element-136"></div>
                    <img src={tomo.img} alt={tomo.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-137" />
                    <div className="absolute top-3 left-3 z-20 bg-amber-600 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-1 rounded-full shadow-sm" data-id="element-138">
                      TOMO {tomo.num}
                    </div>
                  </div>
                  <div className="p-5 md:p-8 w-full md:w-2/3" data-id="element-139">
                    <h3 className="text-lg md:text-2xl font-bold text-slate-900 mb-2 md:mb-3" data-id="element-140">
                      {tomo.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed text-xs md:text-base" data-id="element-141">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Bonuses Section (Gray) */}
        <section className="py-10 md:py-16 bg-slate-100 px-4 relative overflow-hidden border-y border-slate-200" data-id="element-142">
          <div className="max-w-5xl mx-auto relative z-10" data-id="element-143">
            <div className="text-center mb-8 md:mb-12" data-id="element-144">
              <div className="inline-block bg-amber-100 text-amber-700 font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-3 md:mb-4 border border-amber-200 text-xs md:text-sm" data-id="element-145">
                INCLUIDOS GRATIS
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-slate-900" data-id="element-146">
                5 Bonos de Valor Añadido
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-147">
              {[{
              title: 'Plantillas descargables',
              desc: 'Plantillas para evaluación clínica rápida al ingreso.',
              img: 'https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=400&q=80'
            }, {
              title: 'Checklist pre/post',
              desc: 'Checklist para seguimiento postoperatorio en formato editable.',
              img: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&w=400&q=80'
            }, {
              title: 'Mini-curso en video',
              desc: 'Guía para gestión de complicaciones comunes.',
              img: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=400&q=80'
            }, {
              title: 'Guía redes sociales',
              desc: 'Formularios estandarizados para consentimiento y autorización.',
              img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=400&q=80'
            }, {
              title: 'Comunidad privada',
              desc: 'Planillas para control administrativo y registros clínicos.',
              img: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=400&q=80'
            }].map((bono, i) => <div key={i} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-148">
                  <div className="h-24 md:h-32 relative" data-id="element-149">
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent z-10" data-id="element-150"></div>
                    <img src={bono.img} alt={bono.title} className="w-full h-full object-cover" data-id="element-151" />
                    <div className="absolute top-2 right-2 z-20 bg-amber-500 text-white text-[10px] md:text-xs font-bold px-2 py-1 rounded" data-id="element-152">
                      BONO {i + 1}
                    </div>
                  </div>
                  <div className="p-4 md:p-5 relative z-20" data-id="element-153">
                    <h4 className="text-sm md:text-lg font-bold text-slate-900 mb-1" data-id="element-154">
                      {bono.title}
                    </h4>
                    <p className="text-slate-600 text-xs md:text-sm" data-id="element-155">
                      {bono.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Comparison Section (White) */}
        <section className="py-10 md:py-16 px-4 bg-white" data-id="element-156">
          <div className="max-w-4xl mx-auto" data-id="element-157">
            <h2 className="text-2xl md:text-4xl font-bold text-center text-slate-900 mb-8 md:mb-10" data-id="element-158">
              LA REALIDAD SIN EL MEGAPACK
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-slate-200 shadow-lg" data-id="element-159">
              <div className="bg-slate-100 p-6 md:p-8" data-id="element-160">
                <h3 className="text-lg md:text-xl font-bold text-red-600 mb-4 md:mb-6 text-center border-b border-slate-200 pb-3 md:pb-4" data-id="element-161">
                  SIN MEGAPACK
                </h3>
                <ul className="space-y-3 md:space-y-4" data-id="element-162">
                  {['Agenda desordenada, estrés constante.', 'Pérdida de pacientes por mala comunicación.', 'Improvisación en protocolos y gestión.', 'Marketing intuitivo y poco efectivo.', 'Información dispersa e inútil.'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-slate-700 text-xs md:text-base" data-id="element-163">
                      <span className="text-red-500 font-bold mt-0.5" data-id="element-164">✕</span>{' '}
                      {item}
                    </li>)}
                </ul>
              </div>
              <div className="bg-[#0a0f1c] p-6 md:p-8 relative overflow-hidden" data-id="element-165">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl" data-id="element-166"></div>
                <h3 className="text-lg md:text-xl font-bold text-green-400 mb-4 md:mb-6 text-center border-b border-slate-800 pb-3 md:pb-4" data-id="element-167">
                  CON MEGAPACK
                </h3>
                <ul className="space-y-3 md:space-y-4 relative z-10" data-id="element-168">
                  {['Agenda controlada, hasta 10 horas semanales liberadas.', 'Seguimiento automatizado y pacientes más comprometidos.', 'Procesos claros y estandarizados que evitan errores.', 'Estrategia sólida para atraer pacientes ideales.', 'Contenido práctico y directo para aplicar hoy mismo.'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3 text-white text-xs md:text-base" data-id="element-169">
                      <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-green-400 shrink-0 mt-0.5" data-id="element-170" />{' '}
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <PricingSection data-id="element-171" />

        {/* Upsell Details Section (Dark) */}
        <section className="py-10 md:py-16 px-4 bg-[#0a0f1c] border-t border-slate-800 relative" data-id="element-172">
          <div className="max-w-5xl mx-auto relative z-10" data-id="element-173">
            <div className="text-center mb-8 md:mb-12" data-id="element-174">
              <h2 className="text-2xl md:text-4xl font-bold text-white mb-2 md:mb-4" data-id="element-175">
                🚀 ¿QUÉ AGREGA EL MEGAPACK AVANZADO?
              </h2>
              <p className="text-amber-500 font-medium text-sm md:text-base" data-id="element-176">
                Los 4 Tomos VIP Premium que elevan tu práctica a la élite
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-177">
              {[{
              num: 8,
              title: 'Marketing Médico Avanzado Aplicado a Cirugía Plástica',
              desc: 'Estrategias profesionales para posicionar tu marca sin esfuerzo, enfocadas en tu perfil y resultados comprobables.',
              img: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?auto=format&fit=crop&w=600&q=80'
            }, {
              num: 9,
              title: 'Psicología del Paciente Estético y Manejo de Expectativas',
              desc: 'Herramientas para comprender al paciente avanzado y manejar la comunicación en escenarios complejos.',
              img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=600&q=80'
            }, {
              num: 10,
              title: 'Manual de Riesgos, Calidad y Seguridad en Cirugía Estética',
              desc: 'Proceso detallado para mitigar riesgos quirúrgicos, legales y reputacionales, con planillas para monitorización constante.',
              img: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=600&q=80'
            }, {
              num: 11,
              title: 'Formación y Supervisión de Equipos de Alto Desempeño',
              desc: 'Guías y formatos para delegar responsabilidades de forma eficaz, supervisar equipos y asegurar estándares quirúrgicos elevados.',
              img: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80'
            }].map((tomo, i) => <div key={i} className="bg-slate-800/40 backdrop-blur-sm border border-amber-500/20 rounded-xl overflow-hidden flex flex-col sm:flex-row group hover:border-amber-500/40 transition-colors" data-id="element-178">
                  <div className="w-full sm:w-2/5 h-32 sm:h-auto relative" data-id="element-179">
                    <img src={tomo.img} alt={tomo.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-180" />
                    <div className="absolute top-2 left-2 bg-amber-500 text-white text-[10px] md:text-xs font-bold px-2 py-1 rounded" data-id="element-181">
                      TOMO {tomo.num} VIP
                    </div>
                  </div>
                  <div className="p-4 md:p-5 w-full sm:w-3/5 flex flex-col justify-center" data-id="element-182">
                    <h4 className="text-sm md:text-lg font-bold text-white mb-1.5 md:mb-2 leading-tight" data-id="element-183">
                      {tomo.title}
                    </h4>
                    <p className="text-slate-400 text-xs md:text-sm" data-id="element-184">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* FAQ Section (Gray) */}
        <section className="py-10 md:py-16 px-4 bg-slate-100 relative border-y border-slate-200" data-id="element-185">
          <div className="max-w-3xl mx-auto relative z-10" data-id="element-186">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-6 md:mb-10" data-id="element-187">
              PREGUNTAS FRECUENTES
            </h2>
            <div className="bg-white border border-slate-200 rounded-2xl p-4 md:p-6 shadow-sm" data-id="element-188">
              <FAQItem question="¿Cómo recibo el material?" answer="Recibís un email con un link para descargar todo el contenido inmediatamente después de que se procese tu pago. Es 100% digital y tuyo para siempre." data-id="element-189" />
              <FAQItem question="¿Sirve si estoy empezando mi carrera?" answer="Sí, está pensado para cirujanos en todos los niveles. Si estás empezando, te ahorrará años de prueba y error. Si ya tenés experiencia, te ayudará a escalar y optimizar tu tiempo." data-id="element-190" />
              <FAQItem question="¿Está en español latino universal?" answer="Sí, todo el contenido fue redactado con términos claros y aplicables para toda la región de habla hispana." data-id="element-191" />
              <FAQItem question="¿Qué diferencia tiene con otros cursos o libros?" answer="Es 100% práctico, actualizado y específico para el día a día de un cirujano plástico. No es teoría aburrida, son protocolos, plantillas y estrategias listas para aplicar y ver resultados medibles." data-id="element-192" />
            </div>
          </div>
        </section>

        {/* Scarcity & Urgency (Dark) */}
        <section className="py-10 md:py-12 bg-[#1a0505] border-y border-red-900/50 px-4 relative overflow-hidden" data-id="element-193">
          <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-194">
            <h2 className="text-xl md:text-3xl font-bold text-white mb-3 md:mb-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-195">
              <span className="text-red-500" data-id="element-196">🔥</span> ÚLTIMA OPORTUNIDAD
            </h2>
            <p className="text-slate-300 mb-4 md:mb-6 text-sm md:text-base" data-id="element-197">
              No dejes que se acaben los cupos. Los precios subirán pronto.
            </p>

            <div className="bg-slate-900 rounded-full h-3 md:h-4 w-full max-w-md mx-auto mb-2 overflow-hidden border border-slate-700" data-id="element-198">
              <div className="bg-gradient-to-r from-red-600 to-red-500 h-full w-[68%] rounded-full relative" data-id="element-199">
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImEiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTTAgNDBsNDAtNDBIMzBMMCAzMHYxMHptNDAgMEwxMCAwaDEwTDUwIDQwaC0xMHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48L3N2Zz4=')] opacity-30 animate-[slide_2s_linear_infinite]" data-id="element-200"></div>
              </div>
            </div>
            <p className="text-red-400 font-bold text-xs md:text-sm mb-3 md:mb-4" data-id="element-201">
              Cupos restantes: 68% TOMADOS
            </p>
            <p className="text-slate-400 text-xs md:text-sm" data-id="element-202">
              Cuando se acaben los cupos el precio sube y NO vuelve a bajar.
            </p>
          </div>
        </section>

        {/* Duplicated Pricing Section */}
        <PricingSection data-id="element-203" />

        {/* Footer CTA */}
        <section className="py-10 md:py-16 px-4 text-center relative overflow-hidden bg-[#0a0f1c]" data-id="element-204">
          <div className="max-w-3xl mx-auto relative z-10" data-id="element-205">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8" data-id="element-206">
              INVERSIÓN EN TU LIBERTAD Y ÉXITO
            </h2>
            <div className="relative inline-block group" data-id="element-207">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-600 to-red-600 rounded-full blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-208"></div>
              <a href="#pricing" className="relative inline-block bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white font-bold text-base md:text-xl py-3 md:py-4 px-8 md:px-10 rounded-full shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all transform hover:scale-105" data-id="element-209">
                VER OPCIONES DE COMPRA
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-[#050814] py-6 md:py-8 text-center border-t border-slate-800 relative z-10" data-id="element-210">
          <p className="text-slate-500 text-xs md:text-sm mb-1 md:mb-2" data-id="element-211">
            © MegaPack EliteCirujano ™ 2026
          </p>
          <p className="text-slate-600 text-[10px] md:text-xs" data-id="element-212">
            Contacto: soporteacademiaonline.ar@gmail.com
          </p>
        </footer>
      </div>

      <style data-id="element-213">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @keyframes slide {
          0% { transform: translateX(0); }
          100% { transform: translateX(-40px); }
        }
      `}</style>
    </div>;
}